import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";

interface GoogleButtonProps {
  mode: "login" | "register";
}

export function GoogleButton({ mode }: GoogleButtonProps) {
  const { signInWithGoogle } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
      toast({
        title: "Success",
        description: "Successfully signed in with Google",
      });
      navigate("/matches");
    } catch (error) {
      toast({
        title: "Error",
        description: error instanceof Error ? error.message : "Failed to sign in with Google",
        variant: "destructive",
      });
    }
  };

  return (
    <Button 
      variant="outline" 
      type="button"
      onClick={handleGoogleSignIn}
      className="w-full flex items-center justify-center gap-2 h-11 text-base bg-[#fffefa] dark:bg-[#141b2a] hover:bg-accent"
    >
      <img src="/google-logo.svg" alt="Google logo" className="w-5 h-5" />
      <span>
        {mode === "login" ? "Continue with Google" : "Sign up with Google"}
      </span>
    </Button>
  );
}